/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsInfoForKoreaReturnVo } from './GoodsInfoForKoreaReturnVo';
import {
    GoodsInfoForKoreaReturnVoFromJSON,
    GoodsInfoForKoreaReturnVoFromJSONTyped,
    GoodsInfoForKoreaReturnVoToJSON,
    GoodsInfoForKoreaReturnVoToJSONTyped,
} from './GoodsInfoForKoreaReturnVo';

/**
 * 
 * @export
 * @interface OrderInfoForKoreaReturnVo
 */
export interface OrderInfoForKoreaReturnVo {
    /**
     * 商品列表
     * @type {Array<GoodsInfoForKoreaReturnVo>}
     * @memberof OrderInfoForKoreaReturnVo
     */
    goodsInfoForKoreaReturnVOList?: Array<GoodsInfoForKoreaReturnVo>;
}

/**
 * Check if a given object implements the OrderInfoForKoreaReturnVo interface.
 */
export function instanceOfOrderInfoForKoreaReturnVo(value: object): value is OrderInfoForKoreaReturnVo {
    return true;
}

export function OrderInfoForKoreaReturnVoFromJSON(json: any): OrderInfoForKoreaReturnVo {
    return OrderInfoForKoreaReturnVoFromJSONTyped(json, false);
}

export function OrderInfoForKoreaReturnVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForKoreaReturnVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsInfoForKoreaReturnVOList': json['goodsInfoForKoreaReturnVOList'] == null ? undefined : ((json['goodsInfoForKoreaReturnVOList'] as Array<any>).map(GoodsInfoForKoreaReturnVoFromJSON)),
    };
}

export function OrderInfoForKoreaReturnVoToJSON(json: any): OrderInfoForKoreaReturnVo {
    return OrderInfoForKoreaReturnVoToJSONTyped(json, false);
}

export function OrderInfoForKoreaReturnVoToJSONTyped(value?: OrderInfoForKoreaReturnVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsInfoForKoreaReturnVOList': value['goodsInfoForKoreaReturnVOList'] == null ? undefined : ((value['goodsInfoForKoreaReturnVOList'] as Array<any>).map(GoodsInfoForKoreaReturnVoToJSON)),
    };
}

